import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import ColorSwatchButton from 'components/ColorSwatchButton';
import ThumbnailButton from 'components/ThumbnailButton';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

import { COLORWAY_PICKER_APPEARANCES } from './constants';

const ColorwayPickerColorway = ({
  data,
  activeColorwayHandle,
  appearance,
  onSwatchSelect,
  diameter,
  ...otherProps
}) => {
  return (
    <>
      {appearance === COLORWAY_PICKER_APPEARANCES.COLOR_SWATCHES && (
        <ColorSwatchButton
          className="ColorwayPickerColorway ColorwayPickerColorway--color-swatch"
          onClick={() => onSwatchSelect(data.handle)}
          imageUrl={data.swatchImageUrl}
          colors={data.colors}
          diameter={diameter}
          isSelected={activeColorwayHandle === data.handle}
          ariaLabel={I18n.localize('pdp.productSelector.selectColor', {
            colorName: data.colorName,
          })}
          {...otherProps}
        />
      )}
      {appearance === COLORWAY_PICKER_APPEARANCES.THUMBNAILS && (
        <ThumbnailButton
          className="ColorwayPickerColorway ColorwayPickerColorway--thumbnail"
          imageUrl={get(data, ['collectionProductCardImage', 'src'])}
          onClick={() => onSwatchSelect(data.handle)}
          isSelected={activeColorwayHandle === data.handle}
          ariaLabel={I18n.localize('pdp.productSelector.selectColor', {
            colorName: data.colorName,
          })}
          {...otherProps}
        />
      )}
      <style jsx global>
        {`
          .ColorwayPicker .ColorSwatchButton.ColorwayPickerColorway {
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .ColorwayPicker .ThumbnailButton.ThumbnailButton {
            display: block;
          }

          .ColorwayPicker .ThumbnailButton.ThumbnailButton,
          .ColorwayPicker .ThumbnailButton__thumbnail.ThumbnailButton__thumbnail {
            margin: 0;
            width: 100%;
            height: 100%;
          }
        `}
      </style>
    </>
  );
};

ColorwayPickerColorway.propTypes = {
  data: PropTypes.shape({
    image: PropTypes.shape({ src: PropTypes.string, alt: PropTypes.string }),
    colorName: PropTypes.string,
    handle: PropTypes.string,
    swatchImageUrl: PropTypes.string,
    colors: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  activeColorwayHandle: PropTypes.string,
  diameter: PropTypes.number,
  appearance: PropTypes.oneOf(Object.values(COLORWAY_PICKER_APPEARANCES)),
  onSwatchSelect: PropTypes.func,
};

ColorwayPickerColorway.defaultProps = {
  activeColorwayHandle: null,
  appearance: COLORWAY_PICKER_APPEARANCES.COLOR_SWATCHES,
  diameter: Theme.get('spacing') * 4,
  onSwatchSelect: () => {},
};

export default ColorwayPickerColorway;
